// import * as firebase from 'firebase';
// import _ from 'lodash'

const initialState = {}


//Actions
const UNAUTHENTICATED = 'GlobalState/UNAUTHENTICATED'
const GET_JOB = 'JobState/GET_JOB'

// function updateJobs(data) {
//   // if(!data ) {data={}}
//   return {
//     type: GET_JOB,
//     payload: data,
//   };
// }

// export function getOneJob(jid) {
//  return (dispatch, getState) => {
//    let jobs = getState().jobs.jobs;
//    if (!jobs[jid]) {
//      // firebase.database().ref(`jobs/${jid}`).once('value')
//      oneDataPromise(`jobs/${jid}`)
//      .then(snap=>{
//        if(snap.val()!==null){jobs[jid] = snap.val()}
//        dispatch(updateJobs(jobs))
//      })
//    }
//    else {console.log(`already have jid ${jid}`)}
//  };
// }
//
// function oneDataPromise(url) {
//   return new Promise((resolve, reject)=>{
//     firebase.database().ref(`${url}`).once('value')
//     .then(snap=> resolve(snap))
//     .catch(e => {
//       reject(Error(e))
//     })
//   })
// }

export default (state = initialState, action) => {
  switch (action.type) {
    case GET_JOB:
    // console.log('job state');
    // let [jid] = action.payload;
    // applicants[action.jid] = action.payload;
      return {
        ...state,
        [action.jid]: action.payload,
        // [action.payload.jid]: action.payload,
      }

    case UNAUTHENTICATED:
    console.log('job/UNAUTHENTICATED');
    return {
      ...initialState,
    }

    default: return state;

  }
}



// WEBPACK FOOTER //
// ./src/reducers/JobReducer.js